<script>
    import { slide } from 'svelte/transition'
    import { apiURL } from '../../store.js'
    export let resource
    export let display

    let expanded = false

    if (resource.content[0].type == 'Vimeo_Link') {
        var embed = getEmbed(resource.content[0].value)
    }

    function toggleExpanded (event) {
        expanded = !expanded
    }

    async function getEmbed (url) {
        if (url == '') {
            return { html: "<p class='noMedia'>No media has been uploaded to this project yet</p>" }
        }
        const response = await fetch(`https://vimeo.com/api/oembed.json?url=${url}?background=false&portrait=false&title=false&byline=false&responsive=true`)
        const resJSON = await response.json()
        return resJSON
    }
</script>

{#if resource.content[0].type == 'Vimeo_Link'}
    {#await embed then embed}
        {#if expanded}
            <div in:slide out:slide class="embedContainer" class:display>
                {@html embed.html}
                <div class="meta">
                    <h2>
                        {resource.title}
                    </h2>
                    <p class="description">
                        {@html resource.caption}
                    </p>
                    {#if resource.related_paper.length != 0}
                        {#if resource.related_paper[0].full_paper.length != 0}
                            <p class="relatedPaper">
                                Read the related paper:
                                {#if resource.related_paper[0].full_paper[0].type == 'PDF'}
                                    <a target="_blank" href="{apiURL}{resource.related_paper[0].full_paper[0].value.url}">
                                        {resource.related_paper[0].title}
                                    </a>
                                {:else if resource.related_paper[0].full_paper[0].type == 'Link'}
                                    <a target="_blank" href={resource.related_paper[0].full_paper[0].value}>
                                        {resource.related_paper[0].title}
                                    </a>
                                {/if}
                            </p>
                        {/if}
                    {/if}
                </div>
                <div class="closeContainer" on:click={toggleExpanded}>
                    x
                </div>
            </div>
        {:else}
            <div class="resourceContainer" class:display>
                <div class="thumbContainer" on:click={toggleExpanded}>
                    <img class="vimeoThumb" src={embed.thumbnail_url} alt="video thumbnail" />
                    <div class="playIndicator">
                        <svg class="indicator" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.58 393.15">
                            <polygon points="240.58 196.58 0 393.15 0 0 240.58 196.58" />
                        </svg>
                    </div>
                </div>
            </div>
        {/if}
    {/await}
{:else if resource.content[0].type == 'Image'}
    {#if expanded}
        <div in:slide out:slide class="embedContainer" class:display>
            <img src="{apiURL}{resource.content[0].value.url}" alt={resource.title} />
            <div class="meta">
                <h2>
                    {resource.title}
                </h2>
                <p class="description">
                    {@html resource.caption}
                </p>
                {#if resource.related_paper.length != 0}
                    {#if resource.related_paper[0].full_paper.length != 0}
                        <p class="relatedPaper">
                            Read the related paper:
                            {#if resource.related_paper[0].full_paper[0].type == 'PDF'}
                                <a target="_blank" href="{apiURL}{resource.related_paper[0].full_paper[0].value.url}">
                                    {resource.related_paper[0].title}
                                </a>
                            {:else if resource.related_paper[0].full_paper[0].type == 'Link'}
                                <a target="_blank" href={resource.related_paper[0].full_paper[0].value}>
                                    {resource.related_paper[0].title}
                                </a>
                            {/if}
                        </p>
                    {/if}
                {/if}
            </div>
            <div class="closeContainer" on:click={toggleExpanded}>
                x
            </div>
        </div>
    {:else}
        <div class="resourceContainer image" class:display>
            <div class="thumbContainer" on:click={toggleExpanded}>
                <img src="{apiURL}{resource.content[0].value.url}" alt={resource.title} />
            </div>
        </div>
    {/if}
{/if}

<style lang="scss">
    @import "../../styles/vars";

    .resourceContainer {
        position: relative;
        width: 100%;
        margin: 1rem 0;

        img {
            grid-column: 1 / 2;
            max-width: 100%;
        }

        .thumbContainer {
            border: 2px solid var(--pageColor);
            height:0;
            position: relative;
            grid-column: 1 / 2;
            padding-bottom: 100%;

            &:hover {
                cursor: pointer;
            }

            img {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                pointer-events: none;
            }

            .playIndicator {
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
            }

            .revealMore {
                display: block;
                text-align: center;
                width: 100%;
                position: absolute;
                box-sizing: border-box;
                bottom: 0;
                user-select: none;
                font-family: "Work Sans";
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: .05rem;
                font-size: 0.8rem;
                padding: 0.1rem 0.5rem 0.2rem;
                border-top: 2px solid var(--pageColor);
                background-color: var(--pageColor);
                color: white;

                .text {
                    pointer-events: none;
                }
            }

            svg {
                display: inline;
                max-height: 30px;
                max-width: 30px;
                transition: transform 0.4s ease;
                fill: white;
                fill-opacity: 0.8;
                margin: 0 auto;
            }
        }
    }

    .resourceContainer:not(.display), .embedContainer:not(.display) {
        display: none;
    }

    .resourceContainer.image {
        svg {
            fill: var(--pageColor);
        }

        .revealMore {
            background-color: white;
            color: var(--pageColor);
        }
    }

    .embedContainer {
        position: relative;
        grid-column: 1 / 6;
        padding: 1rem;
        border: 2px solid var(--pageColor);
        margin-top: 1rem;

        img {
            max-width: 100%;
        }
    }
    @include respond-to(computer) {
        .closeContainer {
            position: absolute;
            top: 0;
            right: -2rem;
            font-size: 2rem;
            color: var(--pageColor);
            font-weight: bold;

            &:hover {
                cursor: pointer;
            }
        }
    }
    @include respond-to(phone) {
        .closeContainer {
            position: absolute;
            top: 0;
            right: 4px;
            color: var(--pageColor);
            font-weight: bold;

            &:hover {
                cursor: pointer;
            }
        }

        .embedContainer {
            grid-column: 1 / 4;
        }
    }
    :global(.embedContainer .meta) {
        padding-top: 1rem;

        h2 {
            margin: 0;
            font-family: "Work Sans", Helvetica, sans-serif;
            font-feature-settings: 'ss01', 'ss06';
        }

        p {
            margin: 0;
            font-family: "Ysabeau", Times, Serif;
        }

        a {
    text-decoration: none;
            color: black;
            border-bottom: 2px solid var(--pageColor);
        }
    }
</style>
